import { render } from "./ChangeWorkShift.vue?vue&type=template&id=41a4c771"
import script from "./ChangeWorkShift.vue?vue&type=script&lang=js"
export * from "./ChangeWorkShift.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__